import registerSduiMixins from 'src/config/setup/mixins/sdui.js'
import registerOtherMixins from 'src/config/setup/mixins/others.js'

export default function registerMixins(app) {
  registerSduiMixins(app)
  registerOtherMixins(app)
}
